export const footerMoreLinks = {
  'jo-ar': [
    {
      title: 'أكثر',
      items: [
        {
          href: 'https://jo.wingie.com/contact/',
          title: 'التواصل',
        },
        {
          href: 'https://jo.wingie.com/faq/',
          title: 'الأسئلة المتكررة',
        },
        {
          href: 'https://jo.wingie.com/about-us/',
          title: 'تعرّف علينا',
        },
        {
          href: 'https://jo.wingie.com/privacy/',
          title: 'الخصوصية - وينجي',
        },
        {
          href: 'https://jo.wingie.com/terms-and-conditions/',
          title: 'شروط الاستخدام',
        },
        {
          href: 'https://jo.wingie.com/awards/',
          title: 'جوائزنا',
        },
      ],
    },
  ],
  'jo-en': [
    {
      title: 'More',
      items: [
        {
          href: 'https://jo.wingie.com/en/contact/',
          title: 'Contact',
        },
        {
          href: 'https://jo.wingie.com/en/faq/',
          title: 'Frequently Asked Questions',
        },
        {
          href: 'https://jo.wingie.com/en/about-us/',
          title: 'About us',
        },
        {
          href: 'https://jo.wingie.com/en/privacy/',
          title: 'Privacy',
        },
        {
          href: 'https://jo.wingie.com/en/terms-and-conditions/',
          title: 'Terms and Conditions',
        },
        {
          href: 'https://jo.wingie.com/en/awards/',
          title: 'Our Awards',
        },
      ],
    },
  ],
  'jo-es': [
    {
      title: 'Más',
      items: [
        {
          href: 'https://jo.wingie.com/es/contacto/',
          title: 'Contacto',
        },
        {
          href: 'https://jo.wingie.com/es/preguntas-frecuentes/',
          title: 'Preguntas más frecuentes',
        },
        {
          href: 'https://jo.wingie.com/es/acerca-de-nosotros/',
          title: 'Sobre nosotros',
        },
        {
          href: 'https://jo.wingie.com/es/privacidad/',
          title: 'Privacidad',
        },
        {
          href: 'https://jo.wingie.com/es/terminos-y-condiciones/',
          title: 'Términos y condiciones de uso',
        },
        {
          href: 'https://jo.wingie.com/es/awards/',
          title: 'Nuestros premios',
        },
      ],
    },
  ],
  'jo-de': [
    {
      title: 'Mehr',
      items: [
        {
          href: 'https://jo.wingie.com/de/kontakt/',
          title: 'Kontakt',
        },
        {
          href: 'https://jo.wingie.com/de/faq/',
          title: 'Häufig gestellte Fragen - Wingie',
        },
        {
          href: 'https://jo.wingie.com/de/uber-uns/',
          title: 'Über uns',
        },
        {
          href: 'https://jo.wingie.com/de/datenschutz/',
          title: 'Datenschutz & Cookies',
        },
        {
          href: 'https://jo.wingie.com/de/allgemeine-geschaeftsbedingungen/',
          title: 'Allgemeine Geschäftsbedingungen',
        },
        {
          href: 'https://jo.wingie.com/de/awards/',
          title: 'Unsere Auszeichnungen',
        },
      ],
    },
  ],
  'jo-ru': [
    {
      title: 'более',
      items: [
        {
          href: 'https://jo.wingie.com/ru/contact/',
          title: 'Контакты',
        },
        {
          href: 'https://jo.wingie.com/ru/faq/',
          title: 'Часто задаваемые вопросы',
        },
        {
          href: 'https://jo.wingie.com/ru/about-us/',
          title: 'О нас',
        },
        {
          href: 'https://jo.wingie.com/ru/privacy/',
          title: 'Конфиденциальность',
        },
        {
          href: 'https://jo.wingie.com/ru/terms-and-conditions/',
          title: 'Условия и положения',
        },
        {
          href: 'https://jo.wingie.com/ru/awards/',
          title: 'Наши награды',
        },
      ],
    },
  ],
  'jo-it': [
    {
      title: 'Altro',
      items: [
        {
          href: 'https://jo.wingie.com/it/contact/',
          title: 'Contatto',
        },
        // {
        //     href: 'https://jo.wingie.com/it/faq/',
        //     title: 'Domande frequenti',
        // },
        {
          href: 'https://jo.wingie.com/it/about-us/',
          title: 'Chi siamo',
        },
        {
          href: 'https://jo.wingie.com/it/privacy/',
          title: 'Privacy',
        },
        {
          href: 'https://jo.wingie.com/it/terms-and-conditions/',
          title: 'Termini e condizioni',
        },
        {
          href: 'https://jo.wingie.com/it/awards/',
          title: 'I nostri premi',
        },
      ],
    },
  ],
  'jo-fr': [
    {
      title: 'Plus',
      items: [
        {
          href: 'https://jo.wingie.com/fr/contact/',
          title: 'Contact',
        },
        // {
        //     href: 'https://jo.wingie.com/fr/faq/',
        //     title: 'Questions fréquemment posées',
        // },
        {
          href: 'https://jo.wingie.com/fr/about-us/',
          title: 'À propos de nous',
        },
        {
          href: 'https://jo.wingie.com/fr/privacy/',
          title: 'Confidentialité',
        },
        {
          href: 'https://jo.wingie.com/fr/terms-and-conditions/',
          title: 'Termes et conditions',
        },
        {
          href: 'https://jo.wingie.com/fr/awards/',
          title: 'Nos récompenses',
        },
      ],
    },
  ],
  'jo-pt': [
    {
      title: 'Mais',
      items: [
        {
          href: 'https://jo.wingie.com/pt/contact/',
          title: 'Contacto',
        },
        // {
        //     href: 'https://jo.wingie.com/pt/faq/',
        //     title: 'Perguntas frequentes',
        // },
        {
          href: 'https://jo.wingie.com/pt/about-us/',
          title: 'Sobre nós',
        },
        {
          href: 'https://jo.wingie.com/pt/privacy/',
          title: 'Privacidade',
        },
        {
          href: 'https://jo.wingie.com/pt/terms-and-conditions/',
          title: 'Termos e condições',
        },
        {
          href: 'https://jo.wingie.com/pt/awards/',
          title: 'Os nossos prémios',
        },
      ],
    },
  ],
  'jo-ro': [
    {
      title: 'Mai mult',
      items: [
        {
          href: 'https://jo.wingie.com/ro/contact/',
          title: 'Contact',
        },
        // {
        //     href: 'https://jo.wingie.com/ro/faq/',
        //     title: 'Întrebări frecvente',
        // },
        {
          href: 'https://jo.wingie.com/ro/about-us/',
          title: 'Despre noi',
        },
        {
          href: 'https://jo.wingie.com/ro/privacy/',
          title: 'Confidențialitate',
        },
        {
          href: 'https://jo.wingie.com/ro/terms-and-conditions/',
          title: 'Termeni și condiții',
        },
        {
          href: 'https://jo.wingie.com/ro/awards/',
          title: 'Premiile noastre',
        },
      ],
    },
  ],
  'jo-pl': [
    {
      title: 'Więcej',
      items: [
        {
          href: 'https://jo.wingie.com/pl/contact/',
          title: 'Kontakt',
        },
        // {
        //     href: 'https://jo.wingie.com/pl/faq/',
        //     title: 'Najczęściej zadawane pytania',
        // },
        {
          href: 'https://jo.wingie.com/pl/about-us/',
          title: 'O nas',
        },
        {
          href: 'https://jo.wingie.com/pl/privacy/',
          title: 'Prywatność',
        },
        {
          href: 'https://jo.wingie.com/pl/terms-and-conditions/',
          title: 'Regulamin',
        },
        {
          href: 'https://jo.wingie.com/pl/awards/',
          title: 'Nasze nagrody',
        },
      ],
    },
  ],
  'jo-lt': [
    {
      title: 'Daugiau',
      items: [
        {
          href: 'https://jo.wingie.com/lt/contact/',
          title: 'Kontaktai',
        },
        // {
        //     href: 'https://jo.wingie.com/lt/faq/',
        //     title: 'Dažnai užduodami klausimai',
        // },
        {
          href: 'https://jo.wingie.com/lt/about-us/',
          title: 'Apie mus',
        },
        {
          href: 'https://jo.wingie.com/lt/privacy/',
          title: 'Privatumas',
        },
        {
          href: 'https://jo.wingie.com/lt/terms-and-conditions/',
          title: 'Taisyklės ir sąlygos',
        },
        {
          href: 'https://jo.wingie.com/lt/awards/',
          title: 'Mūsų apdovanojimai',
        },
      ],
    },
  ],
  'jo-uz': [
    {
      title: "Ko'proq",
      items: [
        {
          href: 'https://jo.wingie.com/uz/contact/',
          title: 'Aloqa',
        },
        // {
        //     href: 'https://jo.wingie.com/uz/faq/',
        //     title: 'Tez-tez beriladigan savollar',
        // },
        {
          href: 'https://jo.wingie.com/uz/about-us/',
          title: 'Biz haqimizda',
        },
        {
          href: 'https://jo.wingie.com/uz/privacy/',
          title: 'Maxfiylik',
        },
        {
          href: 'https://jo.wingie.com/uz/terms-and-conditions/',
          title: 'Shartlar va qoidalar',
        },
        {
          href: 'https://jo.wingie.com/uz/awards/',
          title: 'Bizning mukofotlarimiz',
        },
      ],
    },
  ],
  'jo-sr': [
    {
      title: 'Више',
      items: [
        {
          href: 'https://jo.wingie.com/sr/contact/',
          title: 'Контакт',
        },
        // {
        //     href: 'https://jo.wingie.com/sr/faq/',
        //     title: 'Често постављана питања',
        // },
        {
          href: 'https://jo.wingie.com/sr/about-us/',
          title: 'О нама',
        },
        {
          href: 'https://jo.wingie.com/sr/privacy/',
          title: 'Приватност',
        },
        {
          href: 'https://jo.wingie.com/sr/terms-and-conditions/',
          title: 'Услови и одредбе',
        },
        {
          href: 'https://jo.wingie.com/sr/awards/',
          title: 'Наше награде',
        },
      ],
    },
  ],
  'jo-ky': [
    {
      title: 'Дагы',
      items: [
        {
          href: 'https://jo.wingie.com/ky/contact/',
          title: 'Байланыш',
        },
        // {
        //     href: 'https://jo.wingie.com/ky/faq/',
        //     title: 'Көп берилүүчү суроолор',
        // },
        {
          href: 'https://jo.wingie.com/ky/about-us/',
          title: 'Биз жөнүндө',
        },
        {
          href: 'https://jo.wingie.com/ky/privacy/',
          title: 'Купуялык',
        },
        {
          href: 'https://jo.wingie.com/ky/terms-and-conditions/',
          title: 'Шарттар жана эрежелер',
        },
        {
          href: 'https://jo.wingie.com/ky/awards/',
          title: 'Биздин сыйлыктарыбыз',
        },
      ],
    },
  ],
  'jo-tg': [
    {
      title: 'Бештар',
      items: [
        {
          href: 'https://jo.wingie.com/tg/contact/',
          title: 'Тамос',
        },
        // {
        //     href: 'https://jo.wingie.com/tg/faq/',
        //     title: 'Саволҳои зиёд пурсидашуда',
        // },
        {
          href: 'https://jo.wingie.com/tg/about-us/',
          title: 'Дар бораи мо',
        },
        {
          href: 'https://jo.wingie.com/tg/privacy/',
          title: 'Махфият',
        },
        {
          href: 'https://jo.wingie.com/tg/terms-and-conditions/',
          title: 'Шартҳо ва қоидаҳо',
        },
        {
          href: 'https://jo.wingie.com/tg/awards/',
          title: 'Мукофотҳои мо',
        },
      ],
    },
  ],
  'jo-kk': [
    {
      title: 'Көбірек',
      items: [
        {
          href: 'https://jo.wingie.com/kk/contact/',
          title: 'Байланыс',
        },
        // {
        //     href: 'https://jo.wingie.com/kk/faq/',
        //     title: 'Жиі қойылатын сұрақтар',
        // },
        {
          href: 'https://jo.wingie.com/kk/about-us/',
          title: 'Біз туралы',
        },
        {
          href: 'https://jo.wingie.com/kk/privacy/',
          title: 'Құпиялылық',
        },
        {
          href: 'https://jo.wingie.com/kk/terms-and-conditions/',
          title: 'Шарттар мен ережелер',
        },
        {
          href: 'https://jo.wingie.com/kk/awards/',
          title: 'Біздің марапаттарымыз',
        },
      ],
    },
  ],
  'jo-nl': [
    {
      title: 'Meer',
      items: [
        {
          href: 'https://jo.wingie.com/nl/contact/',
          title: 'Contact',
        },
        // {
        //     href: 'https://jo.wingie.com/nl/faq/',
        //     title: 'Veelgestelde vragen',
        // },
        {
          href: 'https://jo.wingie.com/nl/about-us/',
          title: 'Over ons',
        },
        {
          href: 'https://jo.wingie.com/nl/privacy/',
          title: 'Privacy',
        },
        {
          href: 'https://jo.wingie.com/nl/terms-and-conditions/',
          title: 'Algemene voorwaarden',
        },
        {
          href: 'https://jo.wingie.com/nl/awards/',
          title: 'Onze prijzen',
        },
      ],
    },
  ],
  'jo-ja': [
    {
      title: 'もっと',
      items: [
        { title: 'お問い合わせ', href: 'https://jo.wingie.com/ja/contact/' },
        { title: 'よくある質問', href: 'https://jo.wingie.com/en/faq/' },
        { title: '会社概要', href: 'https://jo.wingie.com/ja/about-us/' },
        { title: 'プライバシーポリシー', href: 'https://jo.wingie.com/ja/privacy/' },
        { title: '利用規約', href: 'https://jo.wingie.com/ja/terms-and-conditions/' },
        { title: '受賞歴', href: 'https://jo.wingie.com/ja/awards/' },
      ],
    },
  ],
  'jo-zh': [
    {
      title: '更多',
      items: [
        { title: '联系方式', href: 'https://jo.wingie.com/zh/contact/' },
        { title: '常见问题', href: 'https://jo.wingie.com/en/faq/' },
        { title: '关于我们', href: 'https://jo.wingie.com/zh/about-us/' },
        { title: '隐私政策', href: 'https://jo.wingie.com/zh/privacy/' },
        { title: '条款和条件', href: 'https://jo.wingie.com/zh/terms-and-conditions/' },
        { title: '我们的奖项', href: 'https://jo.wingie.com/zh/awards/' },
      ],
    },
  ],
  'jo-ko': [
    {
      title: '더보기',
      items: [
        { title: '연락처', href: 'https://jo.wingie.com/ko/contact/' },
        { title: '자주 묻는 질문', href: 'https://jo.wingie.com/en/faq/' },
        { title: '회사 소개', href: 'https://jo.wingie.com/ko/about-us/' },
        { title: '개인정보처리방침', href: 'https://jo.wingie.com/ko/privacy/' },
        { title: '이용약관', href: 'https://jo.wingie.com/ko/terms-and-conditions/' },
        { title: '수상 내역', href: 'https://jo.wingie.com/ko/awards/' },
      ],
    },
  ],
  'jo-hi': [
    {
      title: 'अधिक',
      items: [
        { title: 'संपर्क करें', href: 'https://jo.wingie.com/hi/contact/' },
        { title: 'सामान्य प्रश्न', href: 'https://jo.wingie.com/en/faq/' },
        { title: 'हमारे बारे में', href: 'https://jo.wingie.com/hi/about-us/' },
        { title: 'गोपनीयता', href: 'https://jo.wingie.com/hi/privacy/' },
        { title: 'नियम और शर्तें', href: 'https://jo.wingie.com/hi/terms-and-conditions/' },
        { title: 'हमारे पुरस्कार', href: 'https://jo.wingie.com/hi/awards/' },
      ],
    },
  ],
  'jo-ta': [
    {
      title: 'மேலும்',
      items: [
        { title: 'தொடர்பு', href: 'https://jo.wingie.com/ta/contact/' },
        { title: 'அடிக்கடி கேட்கப்படும் கேள்விகள்', href: 'https://jo.wingie.com/en/faq/' },
        { title: 'எங்கள் பற்றி', href: 'https://jo.wingie.com/ta/about-us/' },
        { title: 'தனியுரிமை', href: 'https://jo.wingie.com/ta/privacy/' },
        { title: 'விதிமுறைகள்', href: 'https://jo.wingie.com/ta/terms-and-conditions/' },
        { title: 'எங்கள் விருதுகள்', href: 'https://jo.wingie.com/ta/awards/' },
      ],
    },
  ],
  'jo-th': [
    {
      title: 'เพิ่มเติม',
      items: [
        { title: 'ติดต่อเรา', href: 'https://jo.wingie.com/th/contact/' },
        { title: 'คำถามที่พบบ่อย', href: 'https://jo.wingie.com/en/faq/' },
        { title: 'เกี่ยวกับเรา', href: 'https://jo.wingie.com/th/about-us/' },
        { title: 'นโยบายความเป็นส่วนตัว', href: 'https://jo.wingie.com/th/privacy/' },
        { title: 'ข้อกำหนดและเงื่อนไข', href: 'https://jo.wingie.com/th/terms-and-conditions/' },
        { title: 'รางวัลของเรา', href: 'https://jo.wingie.com/th/awards/' },
      ],
    },
  ],
  'jo-ur': [
    {
      title: 'مزید',
      items: [
        { title: 'رابطہ کریں', href: 'https://jo.wingie.com/ur/contact/' },
        { title: 'عمومی سوالات', href: 'https://jo.wingie.com/en/faq/' },
        { title: 'ہمارے بارے میں', href: 'https://jo.wingie.com/ur/about-us/' },
        { title: 'رازداری', href: 'https://jo.wingie.com/ur/privacy/' },
        { title: 'شرائط و ضوابط', href: 'https://jo.wingie.com/ur/terms-and-conditions/' },
        { title: 'ہمارے اعزازات', href: 'https://jo.wingie.com/ur/awards/' },
      ],
    },
  ],
  'jo-ka': [
    {
      title: 'მეტი',
      items: [
        { title: 'კონტაქტი', href: 'https://jo.wingie.com/ka/contact/' },
        { title: 'ხშირად დასმული კითხვები', href: 'https://jo.wingie.com/en/faq/' },
        { title: 'ჩვენ შესახებ', href: 'https://jo.wingie.com/ka/about-us/' },
        { title: 'კონფიდენციალურობა', href: 'https://jo.wingie.com/ka/privacy/' },
        { title: 'წესები და პირობები', href: 'https://jo.wingie.com/ka/terms-and-conditions/' },
        { title: 'ჩვენი ჯილდოები', href: 'https://jo.wingie.com/ka/awards/' },
      ],
    },
  ],
}
